var v4_customData={};
try {
    v4_customData={
      currency: ShopifyAnalytics.meta.currency,
      pageType: ShopifyAnalytics.meta.page.pageType
    };
    Shopify.analytics.publish("sce_page_init", v4_customData); 
  } catch (error) {};
window.dataLayer = window.dataLayer || [];
$(function () {
 var GAiiv = function isInView(o) {
          typeof o[0] === 'undefined' ? o = o : o = o[0];
          if (o instanceof HTMLElement) {
              var vph = window.innerHeight, wpw = window.innerWidth;
              var oRect = o.getBoundingClientRect();
              var ott = oRect.top + oRect.height * 0.5;
              var otl = oRect.left + oRect.width * 0.5;
              return (ott > 0 && ott < vph && otl > 0 && otl < wpw);
          } else { return false; }
 }
      var GAgdb = function gaDebounce(fn, wait) {
          var timeout = null;
          return function () {
              if (timeout !== null) { clearTimeout(timeout); }
              timeout = setTimeout(fn, wait);
          }
 }
  function sendLocalProinfo(promitionid,promoname){
      var ga_prInfo=localStorage.getItem("ga_prInfo");
      if(ga_prInfo){
          localStorage.removeItem("ga_prInfo");
      }
            localStorage.setItem('ga_prInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                    promotion_id: promitionid, 
                    promotion_name: promoname
                    }));
}
 //  var flag = {};
	// function swiperList(){
	// 	var items = new Array();
	// 	var active=$(".swiper-slide-active");
	// 	var index = active.index();
	// 	var iid='xxx',ina='xxx',pid='xxx',pnm='xxx',cnm='xxx',csl='xxx';
	// 	if(flag[index] !== index){
	// 		items.push({
	// 		  "item_id": iid,
	// 		  "item_name": ina,
	// 		  "promotion_id": pid,
	// 		  "promotion_name": pnm,
	// 		  "creative_name": cnm,
	// 		  "creative_slot": csl
	// 		})
	// 		flag[index] = index;
	// 	}
	// 	if(items.length >0){
 //           console.log({
 //               "event":  "dle_view_promotion",
 //               "ecommerce":  {
 //                   "items": items
 //               }
 //           });
	// 	}
	// }
  function sendSwiperClickdata(idselect,index,curmypage){
                   $(idselect).eq(index).each(function(){
                           var imgitems=new Array();
                           var csl=index;
                          if(curmypage.includes('/black-friday-sale')){
                            var iid = "pageBFsale_swiper-slide-banner_image";
                            var pid = "pageBFsale_swiper-slide-banner_image";
                          }else{
                            var iid = "homepage_swiper-slide-banner_image";
                            var pid = "homepage_swiper-slide-banner_image";
                          }
                           var cnm = $(this).find("img").attr("src");
                            var pnm = $(this).find("img").attr("alt");
                          imgitems.push({
                               "item_id": iid,
                               "item_name": pnm,
                               "promotion_id": pid,
                               "promotion_name": pnm,
                               "creative_name": cnm,
                               "creative_slot": csl
                            });
                        // if(imgitems.length>0){
                        //      console.log({
                        //          "event":  eventtype,
                        //          "ecommerce":  {
                        //              "items": imgitems
                        //          }
                        //      });
                        //  };
                       if(imgitems.length>0){
                          dataLayer.push({ ecommerce: null });
                          dataLayer.push({
                            "event": "dle_select_promotion",
                            "ecommerce": {
                              "items": imgitems
                          }
                        });
                      };
                  })
  }
    function sendSwiperViewdata(idselect,index,curmypage){
                   $(idselect).eq(index).each(function(){
                           var imgitems=new Array();
                           var csl=index;
                          if(curmypage.includes('/black-friday-sale')){
                            var iid = "pageBFsale_swiper-slide-banner_image";
                            var pid = "pageBFsale_swiper-slide-banner_image";
                          }else{
                            var iid = "homepage_swiper-slide-banner_image";
                            var pid = "homepage_swiper-slide-banner_image";
                          }
                           var cnm = $(this).find("img").attr("src");
                            var pnm = $(this).find("img").attr("alt");
                          imgitems.push({
                               "item_id": iid,
                               "item_name": pnm,
                               "promotion_id": pid,
                               "promotion_name": pnm,
                               "creative_name": cnm,
                               "creative_slot": csl
                            });
                        // if(imgitems.length>0){
                        //      console.log({
                        //          "event":  eventtype,
                        //          "ecommerce":  {
                        //              "items": imgitems
                        //          }
                        //      });
                        //  };
                       if(imgitems.length>0){
                          dataLayer.push({ ecommerce: null });
                          dataLayer.push({
                            "event": "dle_view_promotion",
                            "ecommerce": {
                              "items": imgitems
                          }
                        });
                      };
                  })
  }

var flag = {};
var mycurpage = window.location.href;
var mySwiper = new Swiper('#pcSwiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  autoplay: {
		delay: 5000,
		disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable:true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on:{
    slideChangeTransitionEnd:function(event){
        var pcswiperCon = document.getElementById("pcSwiper");
        if(GAiiv(pcswiperCon)){
         var img_index = this.realIndex;
         // console.log(img_index+"pc");
        // var swiperOBJ = $("#swiper-ga4-push-pc .slide-content-p").eq(img_index);
        //  var pnm = swiperOBJ.find("img").attr("alt");
          var pcSelection = "#swiper-ga4-push-pc .slide-content-p";
          // var eventType = "dle_view_promotion";
          if(flag[img_index] !== img_index){
            // console.log("hello*****"+img_index);
            sendSwiperViewdata(pcSelection,img_index,mycurpage);
            flag[img_index] = img_index;
          }    
      }
    }
  }
})
// var _w=$("body").width();
// if(_w>1025){  
//    // window.addEventListener('scroll', GAgdb(swiperHandle, 1000));
// }
$("#pcSwiper .swiper-slide").click(function(){
    var indexReal = mySwiper.realIndex;
    var pcSelection = "#swiper-ga4-push-pc .slide-content-p";
    // var eventType = "dle_select_promotion";
    if(mycurpage.includes('/black-friday-sale')){
      var promotionid ="pageBFsale_swiper-slide-banner_image";
    }else{
       var promotionid ="homepage_swiper-slide-banner_image";
    }
    var promoname ="";
   // $(pcSelection).eq(indexReal).each(function(){
   //     var promoname = $(this).find("img").attr("alt");
   // });
  // if(promoname == "" || promoname == null){
  //     promoname = "Swiper Slide IMG"+indexReal;
  //   }
   promoname =  $(pcSelection).eq(indexReal).find("img").attr("alt");
     if(promoname == "" || promoname == null){
       promoname = "Swiper Slide IMG"+indexReal;
    }
    sendLocalProinfo(promotionid,promoname);
    sendSwiperClickdata(pcSelection,indexReal,mycurpage);
    
})

var imgflag ={};
var mySwipers = new Swiper('#mobSwiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable:true,
  }, 
  loop: true,
  autoplay: {
		delay: 5000,
		disableOnInteraction: false,
  },
  on:{
    slideChangeTransitionEnd:function(event){
        var mobswiperCon = document.getElementById("mobSwiper");
        if(GAiiv(mobswiperCon)){  
           img_index = this.realIndex;
           var pcSelection = "#swiper-ga4-push-mob .slide-content-m";
           // var eventType = "dle_view_promotion";
          if(imgflag[img_index] !== img_index){
             sendSwiperViewdata(pcSelection,img_index,mycurpage);
            imgflag[img_index] = img_index;
          }
      }
    }
  }
})
  $("#mobSwiper .swiper-slide").click(function(){
      var indexReal = mySwipers.realIndex;
      var mobSelection = "#swiper-ga4-push-mob .slide-content-m";
      // var eventType = "dle_select_promotion";
      if(mycurpage.includes('/black-friday-sale')){
        var promotionid ="pageBFsale_swiper-slide-banner_image";
      }else{
         var promotionid ="homepage_swiper-slide-banner_image";
      }
      var promoname ="";
      $(mobSelection).eq(indexReal).each(function(){
       var promoname = $(this).find("img").attr("alt");
     });
    //  if(promoname == "" || promoname == null){
    //   promoname = "Swiper Slide IMG"+indexReal;
    // }
    promoname =  $(mobSelection).eq(indexReal).find("img").attr("alt");
     if(promoname == "" || promoname == null){
       promoname = "Swiper Slide IMG"+indexReal;
    }
    sendLocalProinfo(promotionid,promoname);
    sendSwiperClickdata(mobSelection,indexReal,mycurpage);
  })
})

// Tablist products
$(function () {
    function getSectionTit(strselection){
   var newlistname ="homepage_";
   var gettitname ="";
  gettitname = $(strselection).find(".section-header__title").text().trim();
  gettitname = gettitname.replace(/\s+/g,'');
  gettitname = gettitname.toLowerCase();
  newlistname = newlistname + gettitname;
  return newlistname;
}

  function getTabstit(strselection,gettabtit){
    var gettitname="";
    gettitname = $(strselection).text().trim();
    gettitname = gettitname.replace(/\s+/g,'');
    gettitname = gettitname.toLowerCase();
  var newlistname = gettabtit +"_" + gettitname;
  return newlistname;
}
    function getTabstits(strselection){
    var gettitname="";
    gettitname = $(strselection).text().trim();
    gettitname = gettitname.replace(/\s+/g,'');
    gettitname = gettitname.toLowerCase();
  var newlistname = "homepage_"+ gettitname;
  return newlistname;
}
          $(".home-recommend_head").each(function () {
                if ($(this).find(".home-recommend_btn.col").length === 0) {
                    $(this).find(".home-recommend_btn:eq(0)").addClass("active");
                    var $proBox = $(this).siblings(".home-recommend_proBox");
                    $proBox.find('.recommend_pro-list:eq(0)').css('display', 'block');
                    // 首页层级不一样
                    var $proTilBox = $(this).closest('.recomtitle').siblings(".home-recommend_proBox");
                    $proTilBox.find('.recommend_pro-list:eq(0)').css('display', 'block');
                  
                }
            });
          var tabtwoflag={};
          var tabsanflag={};
          var bftabtflag={};
          var bftabsflag={};
  var hometaboflag={};
  var hometabtflag={};
        $(".home-recommend_head .home-recommend_btn").click(function(){
            $(this).addClass("active").siblings().removeClass("active");
            var clickindex = $(this).index();
           // $(this).parents(".recomtitle").next(".home-recommend_proBox").find(".recommend_pro-list").hide();
          // $(this).parents(".recomtitle").next(".home-recommend_proBox").find(".recommend_pro-list").eq(clickindex).show();
            $(this).parent().siblings(".home-recommend_proBox").find('.recommend_pro-list').hide().eq($(this).index()).show();
          // 首页层级不一样
            $(this).closest('.recomtitle').siblings(".home-recommend_proBox").find('.recommend_pro-list').hide().eq($(this).index()).show();
          // console.log(hellohhh+"******");
             // $(".home-recommend_proBox .recommend_pro-list").hide().eq($(this).index()).show();
           //send ga4 event-second tablist product
                 if($("#homepage-tablist-products .tablist_header1").hasClass("active")){
          var proitems=new Array();
        $("#homepage-tablist-products1 .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
               var gettabtit=getSectionTit("#homepage-tablist-products .section-header"); 
                 var newblocktit = getTabstit("#homepage-tablist-products .tablist_header1",gettabtit);
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tablist_pro2";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(tabtwoflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              tabtwoflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
     }
          //second tablist product-end
          // third tablist product-begin
               if($("#homepage-tablist-products .tablist_header2").hasClass("active")){
          var proitems=new Array();
        $("#homepage-tablist-products2 .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
               var gettabtit=getSectionTit("#homepage-tablist-products .section-header"); 
                 var newblocktit = getTabstit("#homepage-tablist-products .tablist_header2",gettabtit);
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tablist_pro3";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(tabsanflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
             tabsanflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
     }
          //third tablist product-end
                    // none title1 - two tablist product-begin
               if($("#home-first-tablist .tablist_header1").hasClass("active")){
          var proitems=new Array();
        $("#home-first-tablist1 .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
               // var gettabtit=getSectionTit("#homepage-tablist-products .section-header"); 
                 var newblocktit = getTabstits("#home-first-tablist .tablist_header1");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tabone_pro2";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(hometaboflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
             hometaboflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
     }
          //none title1 - two tablist product-end
           // none title2 - two tablist product-begin
               if($("#home-second-tablist .tablist_header1").hasClass("active")){
          var proitems=new Array();
        $("#home-second-tablist1 .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
               // var gettabtit=getSectionTit("#homepage-tablist-products .section-header"); 
                 var newblocktit = getTabstits("#home-second-tablist .tablist_header1");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tabtwo_pro2";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(hometabtflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
             hometabtflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
     }
          //none title2 - two tablist product-end
           //send ga4 event-second Bf page tablist product
                 if($("#bf-more-tablists .tablist_header1").hasClass("active")){
          var proitems=new Array();
        $("#bf-more-tablists1 .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
               var gettabtit="pageBFsale_moreyoulllove"; 
          var gettitname = $("#bf-more-tablists .tablist_header1").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = gettabtit+"_"+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_tablist_pro2";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(bftabtflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              bftabtflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
     }
          //second Bf page tablist product-end
          // third Bf page tablist product-begin
               if($("#bf-more-tablists .tablist_header2").hasClass("active")){
          var proitems=new Array();
        $("#bf-more-tablists2 .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
              var gettabtit="pageBFsale_moreyoulllove"; 
          var gettitname = $("#bf-more-tablists .tablist_header2").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = gettabtit+"_"+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_tablist_pro3";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(bftabsflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
             bftabsflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
     }
          //third Bf page tablist product-end
        })
})
//ga4 event swiper
 var GAiiv = function isInView(o) {
          typeof o[0] === 'undefined' ? o = o : o = o[0];
          if (o instanceof HTMLElement) {
              var vph = window.innerHeight, wpw = window.innerWidth;
              var oRect = o.getBoundingClientRect();
              var ott = oRect.top + oRect.height * 0.5;
              var otl = oRect.left + oRect.width * 0.5;
              return (ott > 0 && ott < vph && otl > 0 && otl < wpw);
          } else { return false; }
 }
      var GAgdb = function gaDebounce(fn, wait) {
          var timeout = null;
          return function () {
              if (timeout !== null) { clearTimeout(timeout); }
              timeout = setTimeout(fn, wait);
          }
 }
function sendLocalinfo(promitionid,promoname){
      var ga_prInfo=localStorage.getItem("ga_prInfo");
      if(ga_prInfo){
          localStorage.removeItem("ga_prInfo");
      }
            localStorage.setItem('ga_prInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                    promotion_id: promitionid, 
                    promotion_name: promoname
                    }));
}
function sendProlistname(prolistname){
      var ga_ilInfo=localStorage.getItem("ga_ilInfo");
      if(ga_ilInfo){
          localStorage.removeItem("ga_ilInfo");
      }
           localStorage.setItem('ga_ilInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                     item_list_name: prolistname
                    }));
}
function getLocalinfo(localstring){
  var ga_prInfo=localStorage.getItem(localstring);
   var sitems=new Array(); 
  if(ga_prInfo){
    var obj=JSON.parse(ga_prInfo)
    if(obj.ts>Date.now()){
        last_prid=obj.promotion_id;
        sitems.push(last_prid);
        last_prnm=obj.promotion_name;
        sitems.push(last_prnm);
    }
    return sitems;
  }
}
  function getSectionTit(strselection){
   var newlistname ="homepage_";
   var gettitname ="";
  gettitname = $(strselection).find(".section-header__title").text().trim();
  gettitname = gettitname.replace(/\s+/g,'');
  gettitname = gettitname.toLowerCase();
  newlistname = newlistname + gettitname;
  return newlistname;
}

  function getTabstit(strselection,gettabtit){
    var gettitname="";
    gettitname = $(strselection).text().trim();
    gettitname = gettitname.replace(/\s+/g,'');
    gettitname = gettitname.toLowerCase();
  var newlistname = gettabtit +"_" + gettitname;
  return newlistname;
}
    function sendProindex(productid,listname,index){
                 var ga_proIndex=localStorage.getItem("ga_proIndex");
                 if(ga_proIndex){
                      var proflag =0;
                      var objArrs=JSON.parse(ga_proIndex);
                      for(var i=0;i<objArrs.length;i++){
                        var objInfos = objArrs[i];
                        if(objInfos.productid == productid && objInfos.prolistname == listname){
                            objArrs.splice(i,1);   
                          var arrInfos = {
                              productid: productid,
                              prolistname: listname,
                              proindex: index,
                              ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                           break;
                        }else{
                          proflag++;
                        }
                    }
                    if(proflag == objArrs.length){
                       var arrInfos = {
                               productid: productid,
                               prolistname: listname,
                               proindex: index,
                               ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                    }
                 }else{
                      var proArray = new Array();
                      var arrInfo = {
                             productid: productid,
                             prolistname: listname,
                             proindex: index,
                             ts: Date.now()+3600*24*30*1000
                            };
                       proArray.push(arrInfo);
                     localStorage.setItem('ga_proIndex',JSON.stringify(proArray));
                 }
  }
// Homepage Ga4 event -start
// var urlpage = window.location.href;
  function sendProindex(productid,listname,index){
                 var ga_proIndex=localStorage.getItem("ga_proIndex");
                 if(ga_proIndex){
                      var proflag =0;
                      var objArrs=JSON.parse(ga_proIndex);
                      for(var i=0;i<objArrs.length;i++){
                        var objInfos = objArrs[i];
                        if(objInfos.productid == productid && objInfos.prolistname == listname){
                            objArrs.splice(i,1);   
                          var arrInfos = {
                              productid: productid,
                              prolistname: listname,
                              proindex: index,
                              ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                           break;
                        }else{
                          proflag++;
                        }
                    }
                    if(proflag == objArrs.length){
                       var arrInfos = {
                               productid: productid,
                               prolistname: listname,
                               proindex: index,
                               ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                    }
                 }else{
                      var proArray = new Array();
                      var arrInfo = {
                             productid: productid,
                             prolistname: listname,
                             proindex: index,
                             ts: Date.now()+3600*24*30*1000
                            };
                       proArray.push(arrInfo);
                     localStorage.setItem('ga_proIndex',JSON.stringify(proArray));
                 }
  }
  var bthreeflag={};
  function viewHomeadthree(){
    var imgitems=new Array();
    $("#homepage-text-images .grid__item").each(function(){
           var imgindex=$(this).find("img").attr("alt");
           var csl=$(this).index();
           var iid = "homepage_text-img-ad_image";
           var pid = "homepage_text-img-ad_image";
           var cnm = $(this).find("img").attr("src");
           var pnm = $(this).find("img").attr("alt");
           if(GAiiv($(this))&&bthreeflag[csl] !== csl){
               imgitems.push({
                   "item_id": iid,
                   "item_name": pnm,
                   "promotion_id": pid,
                   "promotion_name": pnm,
                   "creative_name": cnm,
                   "creative_slot": csl
               }); 
               bthreeflag[csl] = csl
           }
    });
     if(imgitems.length>0){
           // console.log({
           //     "event":  "dle_view_promotion",
           //     "ecommerce":  {
           //         "items": imgitems
           //     }
           // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_promotion",
              "ecommerce": {
                "items": imgitems
              }
          })
       };
  }
   function viewtextimgHandle(){
       viewHomeadthree();
   }
  window.addEventListener('scroll', GAgdb(viewtextimgHandle,1000));
  
  $("#homepage-text-images .grid__item").click(function(){
     var imgindex = $(this).index();
     var csl = imgindex;
     var cnm = $(this).find("img").attr("src");
     var pnm = $(this).find("img").attr("alt");
     var iid = "homepage_text-img-ad_image";
     var pid = "homepage_text-img-ad_image";
     var promotionid = pid;
      var promoname = pnm;
      sendLocalinfo(promotionid,promoname);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_promotion",
                      "ecommerce": {
                        "items": [{
                             "item_id": iid,
                             "item_name": pnm,
                             "promotion_id": pid,
                             "promotion_name": pnm,
                             "creative_name": cnm,
                             "creative_slot": csl
                        }]
                      }
                  })
  })
    var bfourflag={};
  function viewHomeadfour(){
    var imgitems=new Array();
    $("#shop-by-moments .grid .grid__item").each(function(){
           var imgindex=$(this).find(".collection-item__title span").text().replace(/\s+/g,"");
           var csl=$(this).index();
           var iid = "homepage_shop-by-moments_image";
           var pid = "homepage_shop-by-moments_image";
           var cnm = $(this).find("img").attr("src");
           var pnm = $(this).find(".collection-item__title span").text().replace(/\s+/g,"");
           if(GAiiv($(this))&&bfourflag[csl] !== csl){
               imgitems.push({
                   "item_id": iid,
                   "item_name": pnm,
                   "promotion_id": pid,
                   "promotion_name": pnm,
                   "creative_name": cnm,
                   "creative_slot": csl
               }); 
               bfourflag[csl] = csl
           }
    });
     if(imgitems.length>0){
           // console.log({
           //     "event":  "dle_view_promotion",
           //     "ecommerce":  {
           //         "items": imgitems
           //     }
           // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_promotion",
              "ecommerce": {
                "items": imgitems
              }
          })
       };
  }
   function viewtextimgsHandle(){
       viewHomeadfour();
   }
  window.addEventListener('scroll', GAgdb(viewtextimgsHandle,1000));
  
  $("#shop-by-moments .grid .grid__item").click(function(){
     var imgindex = $(this).index();
     var csl = imgindex;
     var cnm = $(this).find("img").attr("src");
     var pnm = $(this).find(".collection-item__title span").text().replace(/\s+/g,"");
     var iid = "homepage_shop-by-moments_image";
     var pid = "homepage_shop-by-moments_image";
     var promotionid = pid;
     var promoname = pnm;
      sendLocalinfo(promotionid,promoname);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_promotion",
                      "ecommerce": {
                        "items": [{
                             "item_id": iid,
                             "item_name": pnm,
                             "promotion_id": pid,
                             "promotion_name": pnm,
                             "creative_name": cnm,
                             "creative_slot": csl
                        }]
                      }
                  })
  })
// Homepage New Arrival
  var newflag={};
  function viewHomeprolists(){
    var proitems=new Array();
    $("#homepage-new-arriaval .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
          if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
            product_realsku = "not set";
          }
           var propriceshow = $(this).find(".product-final-price").text();
            propriceshow = propriceshow.replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var newblocktit = getSectionTit("#homepage-new-arriaval .section-header");
           if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
             var prolistname = "homepage_new_arrival";
           }else{
             var prolistname = newblocktit;
           }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&newflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
                newflag[proindexshow] = proindexshow
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
   function viewpronewHandle(){
       viewHomeprolists();
   }
 window.addEventListener('scroll', GAgdb(viewpronewHandle,1000));
  $("#homepage-new-arriaval .grid .grid__item.grid-product").click(function(){
        // var homeNewarrival = document.getElementById("homepage-new-arriaval");
        // if(GAiiv(homeNewarrival)){}
              // sendLocalinfo(promotionid,promoname);
              // var stringarr = getLocalinfo("ga_prInfo");
              // console.log(stringarr);
                 var protitleshow = $(this).find(".real-product-title").text();
                 var proidshow = $(this).find(".productid_ga4").text();
                 var product_sku = $(this).find(".productsku_ga4").text();
                 var product_realsku = $(this).find(".productsku2_ga4").text();
                 if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                    product_realsku = "not set";
                 }
                 var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                 var provariantshow = $(this).find(".productvariant_ga4").text();
                 var newblocktit = getSectionTit("#homepage-new-arriaval .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_new_arrival";
                 }else{
                   var prolistname = newblocktit;
                 }
                 var proindexshow = $(this).index();
                 var proquantityshow = 1;
                 var procurrencyshow = "USD";
                 var procategoryshow = $(this).find(".productcategory_ga4").text();
                 sendProlistname(prolistname);
                 sendProindex(proidshow,prolistname,proindexshow);
      // console.log({
      //          "event":  "dle_select_item",
      //          "ecommerce":  {
      //              "items": [{
      //                        "item_id": proidshow,
      //                        "item_name": protitleshow,
      //                        "product_sku": product_sku,
      //                        "price": propriceshow,
      //                        "item_category": procategoryshow,
      //                        "item_variant": provariantshow,
      //                        "item_list_name": prolistname,
      //                        "index": proindexshow,
      //                        "quantity": proquantityshow,
      //                        "currency": procurrencyshow
      //                   }]
      //          }
      //      });
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                             "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
 }); 
// Homepage HOT SALE PRODUCTS
  var hotflag={};
  function viewHomehotlists(){
    var proitems=new Array();
    $("#homepage-hotsale-products .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
      
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
              var newblocktit = getSectionTit("#homepage-hotsale-products .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_hotsale_products";
                 }else{
                   var prolistname = newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&hotflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              hotflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
   function viewprohotHandle(){
       viewHomehotlists();
   }
 window.addEventListener('scroll', GAgdb(viewprohotHandle,1000));
$("#homepage-hotsale-products .grid .grid__item.grid-product").click(function(){
              // var stringarr = getLocalinfo("ga_prInfo");
              // console.log(stringarr);
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
                   var newblocktit = getSectionTit("#homepage-hotsale-products .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_hotsale_products";
                 }else{
                   var prolistname = newblocktit;
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
  }); 
  // Homepage Super Saving PRODUCTS
  var hosaveflag={};
  function viewHomeSavelists(){
    var proitems=new Array();
    $("#hu-flash-down .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
      
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
              var newblocktit = getSectionTit("#hu-flash-down .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_supersaving_products";
                 }else{
                   var prolistname = newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&hosaveflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              hosaveflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
   function viewprosaveHandle(){
       viewHomeSavelists();
   }
 window.addEventListener('scroll', GAgdb(viewprosaveHandle,1000));
$("#hu-flash-down .grid .grid__item.grid-product").click(function(){
              // var stringarr = getLocalinfo("ga_prInfo");
              // console.log(stringarr);
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
                   var newblocktit = getSectionTit("#hu-flash-down .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_supersaving_products";
                 }else{
                   var prolistname = newblocktit;
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
  }); 
// Homepage HD Lace Wig 
  var hdflag={};
  function viewHomehdlists(){
    var proitems=new Array();
    $("#homepage-hdlacewig .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
               product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var newblocktit = getSectionTit("#homepage-hdlacewig .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_hdlacewig_products";
                 }else{
                   var prolistname = newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&hdflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
             hdflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
   function viewprohdHandle(){
       viewHomehdlists();
   }
 window.addEventListener('scroll', GAgdb(viewprohdHandle,1000));
  $("#homepage-hdlacewig .grid .grid__item.grid-product").click(function(){
              // var stringarr = getLocalinfo("ga_prInfo");
              // console.log(stringarr);
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
                   var newblocktit = getSectionTit("#homepage-hdlacewig .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_hdlacewig_products";
                 }else{
                   var prolistname = newblocktit;
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
  }); 
// Homepage Color wig product lists
  var colorflg={};
  function viewHomecolorlists(){
    var proitems=new Array();
    $("#homepage-colorwig .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
            var newblocktit = getSectionTit("#homepage-colorwig .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_colorwig_products";
                 }else{
                   var prolistname = newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
          sendProlistname(prolistname);
           if(GAiiv($(this))&&hdflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              colorflg[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
   function viewprocolorHandle(){
       viewHomecolorlists();
   }
 window.addEventListener('scroll', GAgdb(viewprocolorHandle,1000));
 $("#homepage-colorwig .grid .grid__item.grid-product").click(function(){
               // var stringarr = getLocalinfo("ga_prInfo");
               // console.log(stringarr);
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                        product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
                   var newblocktit = getSectionTit("#homepage-colorwig .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_colorwig_products";
                 }else{
                   var prolistname = newblocktit;
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
}); 
  // homepage tablist
    function getTabstit(strselection,gettabtit){
    var gettitname="";
      gettitname = $(strselection).text().trim();
      gettitname = gettitname.replace(/\s+/g,'');
      gettitname = gettitname.toLowerCase();
  var newlistname = gettabtit +"_" + gettitname;
  return newlistname;
}
  function getSectionTit(strselection){
   var newlistname ="homepage_";
   var gettitname ="";
  gettitname = $(strselection).find(".section-header__title").text().trim();
  gettitname = gettitname.replace(/\s+/g,'');
  gettitname = gettitname.toLowerCase();
  newlistname = newlistname + gettitname;
  return newlistname;
}
// Homepage tablists - 0
  var taboneflg ={};
  function viewHometablists(){
  if($(".home-recommend_btn").eq(0).hasClass("active")){
    var proitems=new Array();
    $("#homepage-tablist-products0 .grid .grid__item.grid-product").each(function(){
          var newlistname ="homepage_";
          var gettitname ="";
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
            var gettabtit=$("#homepage-tablist-products .section-header").find(".section-header__title").text().trim().replace(/\s+/g,'').toLowerCase(); 
            gettabtit = newlistname+gettabtit;
            var gettitname = $("#homepage-tablist-products .tablist_header0").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = gettabtit+"_"+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tablist_pro1";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
          // console.log("hello***"+prolistname);
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           sendProlistname(prolistname);
           if(GAiiv($(this))&&taboneflg[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              taboneflg[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
}
   function viewprotabHandle(){
       viewHometablists();
   }
 window.addEventListener('scroll', GAgdb(viewprotabHandle,1000));
  // Homepage tablists-none one - 0
  var tabnoneoflg ={};
  function viewHometabnoneo(){
  if($(".home-recommend_btn").eq(0).hasClass("active")){
    var proitems=new Array();
    $("#home-first-tablist0 .grid .grid__item.grid-product").each(function(){
          var newlistname ="homepage_";
          var gettitname ="";
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
            // var gettabtit=$("#homepage-tablist-products .section-header").find(".section-header__title").text().trim().replace(/\s+/g,'').toLowerCase(); 
            // gettabtit = newlistname+gettabtit;
            var gettitname = $("#home-first-tablist .tablist_header0").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = newlistname+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tabone_pro1";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
          // console.log("hello***"+prolistname);
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           sendProlistname(prolistname);
           if(GAiiv($(this))&&tabnoneoflg[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              tabnoneoflg[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
}
   function viewnoneoHandle(){
       viewHometabnoneo();
   }
 window.addEventListener('scroll', GAgdb(viewnoneoHandle,1000));
    // Homepage tablists-none two - 0
  var tabnonetflg ={};
  function viewHometabnonet(){
  if($(".home-recommend_btn").eq(0).hasClass("active")){
    var proitems=new Array();
    $("#home-second-tablist0 .grid .grid__item.grid-product").each(function(){
          var newlistname ="homepage_";
          var gettitname ="";
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
            // var gettabtit=$("#homepage-tablist-products .section-header").find(".section-header__title").text().trim().replace(/\s+/g,'').toLowerCase(); 
            // gettabtit = newlistname+gettabtit;
            var gettitname = $("#home-second-tablist .tablist_header0").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = newlistname+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tabtwo_pro1";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
          // console.log("hello***"+prolistname);
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           sendProlistname(prolistname);
           if(GAiiv($(this))&&tabnonetflg[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              tabnonetflg[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
}
   function viewnonetHandle(){
       viewHometabnonet();
   }
 window.addEventListener('scroll', GAgdb(viewnonetHandle,1000));
 $("#homepage-tablist-products0 .grid .grid__item.grid-product").click(function(){
                  var newlistname ="homepage_";
                  var gettitname ="";
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
                      var gettabtit=$("#homepage-tablist-products .section-header").find(".section-header__title").text().trim().replace(/\s+/g,'').toLowerCase(); 
            gettabtit = newlistname+gettabtit;
            var gettitname = $("#homepage-tablist-products .tablist_header0").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = gettabtit+"_"+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tablist_pro1";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
 }); 
// Homepage tablists - 1

// function viewHometabolists(){

//   }
//   function viewprotaboHandle(){
//     var tablistcon = document.getElementsByClassName("recom-container");
//     if(GAiiv(tablistcon)){
//         viewHometabolists();
//     }
//    }
//  window.addEventListener('scroll', GAgdb(viewprotaboHandle,1000));
 $("#homepage-tablist-products1 .grid .grid__item.grid-product").click(function(){
                      var newlistname ="homepage_";
                  var gettitname ="";
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                      product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
                 var gettabtit=$("#homepage-tablist-products .section-header").find(".section-header__title").text().trim().replace(/\s+/g,'').toLowerCase(); 
            gettabtit = newlistname+gettabtit;
            var gettitname = $("#homepage-tablist-products .tablist_header1").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = gettabtit+"_"+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tablist_pro2";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                     sendProlistname(prolistname);
                   sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
                }); 
// Homepage tablists - 2

// function viewHometabtlists(){

//   }
//   function viewprotabtHandle(){
//     var tablistcon = document.getElementsByClassName("recom-container");
//     if(GAiiv(tablistcon)){
//         viewHometabtlists();
//     }
//    }
//  window.addEventListener('scroll', GAgdb(viewprotabtHandle,1000));
$("#homepage-tablist-products2 .grid .grid__item.grid-product").click(function(){
                  var newlistname ="homepage_";
                  var gettitname ="";
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                      product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
               var gettabtit=$("#homepage-tablist-products .section-header").find(".section-header__title").text().trim().replace(/\s+/g,'').toLowerCase(); 
            gettabtit = newlistname+gettabtit;
            var gettitname = $("#homepage-tablist-products .tablist_header2").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = gettabtit+"_"+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tablist_pro3";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                    sendProlistname(prolistname);
                    sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
  }); 
  // Homepage tablist--101
   $("#home-first-tablist0 .grid .grid__item.grid-product").click(function(){
                  var newlistname ="homepage_";
                  var gettitname ="";
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
            //           var gettabtit=$("#homepage-tablist-products .section-header").find(".section-header__title").text().trim().replace(/\s+/g,'').toLowerCase(); 
            // gettabtit = newlistname+gettabtit;
            var gettitname = $("#home-first-tablist .tablist_header0").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = newlistname+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tabone_pro1";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
 }); 
    // Homepage tablist--102
   $("#home-first-tablist1 .grid .grid__item.grid-product").click(function(){
                  var newlistname ="homepage_";
                  var gettitname ="";
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
            //           var gettabtit=$("#homepage-tablist-products .section-header").find(".section-header__title").text().trim().replace(/\s+/g,'').toLowerCase(); 
            // gettabtit = newlistname+gettabtit;
            var gettitname = $("#home-first-tablist .tablist_header1").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = newlistname+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tabone_pro2";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
 }); 
      // Homepage tablist--102
   $("#home-second-tablist0 .grid .grid__item.grid-product").click(function(){
                  var newlistname ="homepage_";
                  var gettitname ="";
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
            //           var gettabtit=$("#homepage-tablist-products .section-header").find(".section-header__title").text().trim().replace(/\s+/g,'').toLowerCase(); 
            // gettabtit = newlistname+gettabtit;
            var gettitname = $("#home-second-tablist .tablist_header0").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = newlistname+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tabtwo_pro1";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
 }); 
      // Homepage tablist--104
   $("#home-second-tablist1 .grid .grid__item.grid-product").click(function(){
                  var newlistname ="homepage_";
                  var gettitname ="";
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
            //           var gettabtit=$("#homepage-tablist-products .section-header").find(".section-header__title").text().trim().replace(/\s+/g,'').toLowerCase(); 
            // gettabtit = newlistname+gettabtit;
            var gettitname = $("#home-second-tablist .tablist_header1").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = newlistname+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "homepage_tabtwo_pro2";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
 }); 
// Homepage category lists
  $("#home-category-container .multicolumn-list .multicolumn-list__item").click(function(){
    var label = $(this).find(".multicolumn-card__title").text().trim();
      dataLayer.push({
		"event_categoty":"home_page",
		"event_action": "menu_click",
	    "event_label": label,
	    "event": "cme_category_click"
	})
  }); 
  // Homepage tablists - 3
// var tabsiflag={};
// function viewHometabttlists(){
//      if($(".home-recommend_btn").eq(3).hasClass("active")){
//           var proitems=new Array();
//         $("#homepage-tablist-products3 .grid .grid__item.grid-product").each(function(){
//            var protitleshow = $(this).find(".real-product-title").text();
//            var proidshow = $(this).find(".productid_ga4").text();
//            var product_sku = $(this).find(".productsku_ga4").text();
//            var product_realsku = $(this).find(".productsku2_ga4").text();
//            if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
//               product_realsku = "not set";
//            }
//            var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
//            var provariantshow = $(this).find(".productvariant_ga4").text();
//                var gettabtit=getSectionTit("#homepage-tablist-products .section-header"); 
//                  var newblocktit = getTabstit("#homepage-tablist-products .tablist_header3",gettabtit);
//                  if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
//                    var prolistname = "homepage_tablist_item04";
//                  }else{
//                    if(newblocktit.indexOf('-')>-1){
//                       var prolistname = newblocktit.replace("-",'');
//                    }else{
//                      var prolistname = newblocktit;
//                    }  
//                  }
//            var proindexshow = $(this).index();
//            var proquantityshow = 1;
//            var procurrencyshow = "USD";
//            var procategoryshow = $(this).find(".productcategory_ga4").text();
//            if(GAiiv($(this))&&tabsiflag[proindexshow] !== proindexshow){
//                proitems.push({
//                    "item_id": proidshow,
//                    "item_name": protitleshow,
//                    "product_sku": product_realsku,
//                    "price": propriceshow,
//                    "item_category": procategoryshow,
//                    "item_variant": provariantshow,
//                    "item_list_name": prolistname,
//                    "index": proindexshow,
//                    "quantity": proquantityshow,
//                    "currency": procurrencyshow
//                });
//              tabsiflag[proindexshow] = proindexshow;
//            }
//     });
//      if(proitems.length>0){
//              // console.log({
//              //     "event":  "dle_view_promotion",
//              //     "ecommerce":  {
//              //         "items": proitems
//              //     }
//              // });
//           dataLayer.push({ ecommerce: null });
//           dataLayer.push({
//               "event": "dle_view_item_list",
//               "ecommerce": {
//                 "items": proitems
//               }
//           })
//        };
//      }
//   }
//   function viewprotabttHandle(){
//     var tablistcon = document.getElementsByClassName("recom-container");
//     if(GAiiv(tablistcon)){
//         viewHometabttlists();
//     }
//    }
//  window.addEventListener('scroll', GAgdb(viewprotabttHandle,1000));
// $("#homepage-tablist-products3 .grid .grid__item.grid-product").click(function(){
//                    var protitleshow = $(this).find(".real-product-title").text();
//                    var proidshow = $(this).find(".productid_ga4").text();
//                    var product_sku = $(this).find(".productsku_ga4").text();
//                    var product_realsku = $(this).find(".productsku2_ga4").text();
//                    if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
//                       product_realsku = "not set";
//                    }
//                    var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
//                    var provariantshow = $(this).find(".productvariant_ga4").text();
//                   var gettabtit=getSectionTit("#homepage-tablist-products .section-header"); 
//                  var newblocktit = getTabstit("#homepage-tablist-products .tablist_header3",gettabtit);
//                  if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
//                    var prolistname = "homepage_tablist_item04";
//                  }else{
//                    if(newblocktit.indexOf('-')>-1){
//                       var prolistname = newblocktit.replace("-",'');
//                    }else{
//                      var prolistname = newblocktit;
//                    }  
//                  }
//                    var proindexshow = $(this).index();
//                    var proquantityshow = 1;
//                    var procurrencyshow = "USD";
//                    var procategoryshow = $(this).find(".productcategory_ga4").text();
//                     sendProlistname(prolistname);
//                   sendProindex(proidshow,prolistname,proindexshow);
//                 // select_promotion 
//                   dataLayer.push({ ecommerce: null });
//                   dataLayer.push({
//                       "event": "dle_select_item",
//                       "ecommerce": {
//                         "items": [{
//                               "item_id": proidshow,
//                              "item_name": protitleshow,
//                              "product_sku": product_realsku,
//                              "price": propriceshow,
//                              "item_category": procategoryshow,
//                              "item_variant": provariantshow,
//                              "item_list_name": prolistname,
//                              "index": proindexshow,
//                              "quantity": proquantityshow,
//                              "currency": procurrencyshow
//                         }]
//                       }
//                   })
//   }); 
// homepage ga4 - end
// Black Friday Page Sale
if(window.location.href.includes('/black-friday-sale-for')) {
    function getSectionBfTit(strselection){
   var newlistname ="pageBFsale_";
   var gettitname ="";
  gettitname = $(strselection).find(".section-header__title").text().trim();
  gettitname = gettitname.replace(/\s+/g,'');
  gettitname = gettitname.toLowerCase();
  newlistname = newlistname + gettitname;
  return newlistname;
}
  // BFpage Bang Wig PRODUCTS
  var bangwigflg={};
  function viewHomebanglists(){
    var proitems=new Array();
    $("#curtain-product-lists .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
      
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
              var newblocktit = getSectionBfTit("#curtain-product-lists .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_bangwig_products";
                 }else{
                   var prolistname = newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&bangwigflg[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              bangwigflg[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
   function viewprobangHandle(){
       viewHomebanglists();
   }
 window.addEventListener('scroll', GAgdb(viewprobangHandle,1000));
$("#curtain-product-lists .grid .grid__item.grid-product").click(function(){
              // var stringarr = getLocalinfo("ga_prInfo");
              // console.log(stringarr);
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
                   var newblocktit = getSectionBfTit("#curtain-product-lists .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_bangwig_products";
                 }else{
                   var prolistname = newblocktit;
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
  }); 
  //BFpage 8*5 HD lace wig
    var bfhdwigsflg={};
  function viewHomebfhdlists(){
    var proitems=new Array();
    $("#hdlacewig-product-lists .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
      
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
              var newblocktit = getSectionBfTit("#hdlacewig-product-lists .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_85HDlacewig_products";
                 }else{
                   var prolistname = newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&bfhdwigsflg[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              bfhdwigsflg[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
   function viewprobfhdHandle(){
       viewHomebfhdlists();
   }
 window.addEventListener('scroll', GAgdb(viewprobfhdHandle,1000));
$("#hdlacewig-product-lists .grid .grid__item.grid-product").click(function(){
              // var stringarr = getLocalinfo("ga_prInfo");
              // console.log(stringarr);
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
                   var newblocktit = getSectionBfTit("#hdlacewig-product-lists .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_85HDlacewig_products";
                 }else{
                   var prolistname = newblocktit;
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
  }); 
    //BFpage 360 HD lace wig
    var bfyhdwigflg={};
  function viewHomebfwigtlists(){
    var proitems=new Array();
    $("#twohdwig-product-lists .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
      
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
              var newblocktit = getSectionBfTit("#twohdwig-product-lists .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_360HDlacewig_products";
                 }else{
                   var prolistname = newblocktit;
                 }
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&bfyhdwigflg[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              bfyhdwigflg[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
   function viewprobfhdtwHandle(){
       viewHomebfwigtlists();
   }
 window.addEventListener('scroll', GAgdb(viewprobfhdtwHandle,1000));
$("#twohdwig-product-lists .grid .grid__item.grid-product").click(function(){
              // var stringarr = getLocalinfo("ga_prInfo");
              // console.log(stringarr);
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
                   var newblocktit = getSectionBfTit("#twohdwig-product-lists .section-header");
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_360HDlacewig_products";
                 }else{
                   var prolistname = newblocktit;
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
  }); 
  // Black Friday tablists - 0
  var tabbfoflg ={};
  function viewBftablists(){
  if($(".home-recommend_btn").eq(0).hasClass("active")){
    var proitems=new Array();
    $("#bf-more-tablists0 .grid .grid__item.grid-product").each(function(){
          var gettabtit ="pageBFsale_moreyoulllove";
          var gettitname ="";
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
             gettitname = $("#bf-more-tablists .tablist_header0").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = gettabtit+"_"+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_tablist_pro1";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
          // console.log("hello***"+prolistname);
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           sendProlistname(prolistname);
           if(GAiiv($(this))&&tabbfoflg[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              tabbfoflg[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
}
   function viewproBftabHandle(){
       viewBftablists();
   }
 window.addEventListener('scroll', GAgdb(viewproBftabHandle,1000));
 $("#bf-more-tablists0 .grid .grid__item.grid-product").click(function(){
                  var gettabtit ="pageBFsale_moreyoulllove";
                  var gettitname ="";
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
             gettitname = $("#bf-more-tablists .tablist_header0").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = gettabtit+"_"+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_tablist_pro1";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                  sendProlistname(prolistname);
                  sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
 }); 
// Black Friday page tablists - 1

// function viewHometabolists(){

//   }
//   function viewprotaboHandle(){
//     var tablistcon = document.getElementsByClassName("recom-container");
//     if(GAiiv(tablistcon)){
//         viewHometabolists();
//     }
//    }
//  window.addEventListener('scroll', GAgdb(viewprotaboHandle,1000));
 $("#bf-more-tablists1 .grid .grid__item.grid-product").click(function(){
                  var gettabtit ="pageBFsale_moreyoulllove";
                  var gettitname ="";
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
             gettitname = $("#bf-more-tablists .tablist_header1").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = gettabtit+"_"+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_tablist_pro2";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                     sendProlistname(prolistname);
                   sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
                }); 
// Black Friday page tablists - 2

// function viewHometabtlists(){

//   }
//   function viewprotabtHandle(){
//     var tablistcon = document.getElementsByClassName("recom-container");
//     if(GAiiv(tablistcon)){
//         viewHometabtlists();
//     }
//    }
//  window.addEventListener('scroll', GAgdb(viewprotabtHandle,1000));
$("#bf-more-tablists2 .grid .grid__item.grid-product").click(function(){
                  var gettabtit ="pageBFsale_moreyoulllove";
                  var gettitname ="";
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
             gettitname = $("#bf-more-tablists .tablist_header2").text().trim().replace(/\s+/g,'').toLowerCase();
            var newblocktit = gettabtit+"_"+gettitname;
                 if(newblocktit=='' || newblocktit==null || newblocktit==undefined || newblocktit.length == 0){
                   var prolistname = "pageBFsale_tablist_pro3";
                 }else{
                   if(newblocktit.indexOf('-')>-1){
                      var prolistname = newblocktit.replace("-",'');
                   }else{
                     var prolistname = newblocktit;
                   }  
                 }
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
                    sendProlistname(prolistname);
                    sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
  }); 
}
// collections ga4 event
if(window.location.href.includes('/collectionsssssssssssssssssssss/')) {
  function sendLocallistname(listname){
      var ga_ilInfo=localStorage.getItem("ga_ilInfo");
      if(ga_ilInfo){
          localStorage.removeItem("ga_ilInfo");
      }
            localStorage.setItem('ga_ilInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                     item_list_name: listname
                    }));
}
  function sendPromoinfo(){
       var ga_prInfo=localStorage.getItem("ga_prInfo");
      if(ga_prInfo){
          localStorage.removeItem("ga_prInfo");
      }
  }
function getLocallistname(){
  var ga_ilInfo=localStorage.getItem("ga_ilInfo");
   var sitems=new Array(); 
  if(ga_prInfo){
    var obj=JSON.parse(ga_ilInfo)
    if(obj.ts>Date.now()){
        last_ilnm=obj.item_list_name;
        sitems.push(last_ilnm);
    }
    return sitems;
  }
}
  function sendProindex(productid,listname,index){
                 var ga_proIndex=localStorage.getItem("ga_proIndex");
                 if(ga_proIndex){
                      var proflag =0;
                      var objArrs=JSON.parse(ga_proIndex);
                      for(var i=0;i<objArrs.length;i++){
                        var objInfos = objArrs[i];
                        if(objInfos.productid == productid && objInfos.prolistname == listname){
                            objArrs.splice(i,1);   
                          var arrInfos = {
                              productid: productid,
                              prolistname: listname,
                              proindex: index,
                              ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                           break;
                        }else{
                          proflag++;
                        }
                    }
                    if(proflag == objArrs.length){
                       var arrInfos = {
                               productid: productid,
                               prolistname: listname,
                               proindex: index,
                               ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                    }
                 }else{
                      var proArray = new Array();
                      var arrInfo = {
                             productid: productid,
                             prolistname: listname,
                             proindex: index,
                             ts: Date.now()+3600*24*30*1000
                            };
                       proArray.push(arrInfo);
                     localStorage.setItem('ga_proIndex',JSON.stringify(proArray));
                 }
  }
   var collectflg={};
  var pagenum = 1;
   if(window.location.href.includes('page=')){
    var myurl = window.location.href;
    var strlength= myurl.length;
    var poseindex = myurl.indexOf("page=");
     pagenum = myurl.substring(poseindex+5,strlength);
     pagenum = pagenum.replace(/[^0-9]/g,"");
    var regPos = /^[0-9]+.?[0-9]*/; 
    if(regPos.test(pagenum) ){
        pagenum = pagenum;
    }else{
        pagenum = 1;
    }
   }
    function viewCollectionlists(){
      var proitems=new Array();
      var getId = document.getElementById('collectionpage-id');
      var prolistname = getId.getAttribute("data-url-text");
    $("#CollectionSection .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var proindexshow = $(this).index();
            proindexshow = (pagenum-1)*28+proindexshow;
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&collectflg[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
               collectflg[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_item_list",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
   function viewcollectionHandle(){
       viewCollectionlists();
   }
  // window.addEventListener('load',function(){
  //     var catgoryObj= document.getElementById('shopify-section-collection-template');
  //     if(GAiiv(catgoryObj)){
  //         viewCollectionlists();
  //     }
  // })
 window.addEventListener('scroll', GAgdb(viewcollectionHandle,1000));
 $("#CollectionSection .grid .grid__item.grid-product").click(function(){
      var getId = document.getElementById('collectionpage-id');
      var prolistname = getId.getAttribute("data-url-text");
      sendLocallistname(prolistname);
                   var protitleshow = $(this).find(".real-product-title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                      product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
                   var proindexshow = $(this).index();
                   proindexshow = (pagenum-1)*28+proindexshow;
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
        sendProindex(proidshow,prolistname,proindexshow);
       if(window.location.href.includes('flag=homeprom')){
           var refurl=document.referrer;
           if(refurl.indexOf("www.hermosahair.com")>-1){
                      var ga_prInfo=localStorage.getItem("ga_prInfo");
                      if(ga_prInfo){
                        var obj=JSON.parse(ga_prInfo)
                        if(obj.ts>Date.now()){
                          var last_prid=obj.promotion_id;
                          var last_prnm=obj.promotion_name;
                        }else{
                          localStorage.removeItem("ga_prInfo");
                          var last_prid=undefined;
                          var last_prnm=undefined; 
                        }
                      }else{
                         var last_prid=undefined;
                         var last_prnm=undefined; 
                      } 
             //localStorage.removeItem("ga_cproInfos");
                 var ga_cproInfo=localStorage.getItem("ga_cproInfo");
                 if(ga_cproInfo){
                      var proflag =0;
                      var objArrs=JSON.parse(ga_cproInfo);
                      for(var i=0;i<objArrs.length;i++){
                        var objInfos = objArrs[i];
                        if(objInfos.proid == proidshow){
                            objArrs.splice(i,1);   
                          var arrInfos = {
                              proid: proidshow,
                             prolname: prolistname,
                             promotionid: last_prid,
                             promotionname: last_prnm,
                             ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_cproInfo',JSON.stringify(objArrs));
                           break;
                        }else{
                          proflag++;
                        }
                    }
                    if(proflag == objArrs.length){
                       var arrInfos = {
                               proid: proidshow,
                               prolname: prolistname,
                               promotionid: last_prid,
                               promotionname: last_prnm,
                               ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_cproInfo',JSON.stringify(objArrs));
                    }
                 }else{
                      var proArray = new Array();
                      var arrInfo = {
                             proid: proidshow,
                             prolname: prolistname,
                             promotionid: last_prid,
                             promotionname: last_prnm,
                             ts: Date.now()+3600*24*30*1000
                            };
                       proArray.push(arrInfo);
                     localStorage.setItem('ga_cproInfo',JSON.stringify(proArray));
                 }
        }
   }
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
    }); 
}

if(window.location.href.includes('/productsssssssssssssssssssssssssss/')) {
    function sendLocallistname(listname){
      var ga_ilInfo=localStorage.getItem("ga_ilInfo");
      if(ga_ilInfo){
          localStorage.removeItem("ga_ilInfo");
      }
            localStorage.setItem('ga_ilInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                     item_list_name: listname
                    }));
}
    function sendPromoinfo(){
       var ga_prInfo=localStorage.getItem("ga_prInfo");
      if(ga_prInfo){
          localStorage.removeItem("ga_prInfo");
      }
  }
  var recentflag={};
  function viewRecentlists(){
      var proitems=new Array();
    $("#RecentlyViewed-container .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".grid-product__title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
               product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var prolistname = "productpage_recently_viewed-products";
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&recentflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
               recentflag[proindexshow] = proindexshow;
           }
        $(this).click(function(){
          var prolistname = "productpage_recently_viewed-products";
                sendLocallistname(prolistname);
                   var protitleshow = $(this).find(".grid-product__title").text();
                   var proidshow = $(this).find(".productid_ga4").text();
                   var product_sku = $(this).find(".productsku_ga4").text();
                   var product_realsku = $(this).find(".productsku2_ga4").text();
                   if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                     product_realsku = "not set";
                   }
                   var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
                   var provariantshow = $(this).find(".productvariant_ga4").text();
                   var prolistname = "productpage_recently_viewed-products";
                   var proindexshow = $(this).index();
                   var proquantityshow = 1;
                   var procurrencyshow = "USD";
                   var procategoryshow = $(this).find(".productcategory_ga4").text();
          sendProindex(proidshow,prolistname,proindexshow);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                              "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
        })
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
   function viewrecentlyHandle(){
       viewRecentlists();
   }
 window.addEventListener('scroll', GAgdb(viewrecentlyHandle,1000));
}
// cart page ga4 event
if(window.location.href.includes('/cartssssssssssssssss')) {
  function isNumber(val){
    var regPos = /^[0-9]+.?[0-9]*/; 
    if(regPos.test(val) ){
        return true;
    }else{
        return false;
    }
  }
    function getListname(productid,provarid){
          var ga_cartInfos=localStorage.getItem("ga_cartInfos");
           if(ga_cartInfos){
                      var objArr=JSON.parse(ga_cartInfos);
                      var flagno = 0;
                     var flagtwo = 0;
                      for(var i=0;i<objArr.length;i++){
                        var objInfo = objArr[i];
                        if(objInfo.proid == productid){
                          if(objInfo.provarid == provarid){
                            var prolistname = objInfo.prolname;
                            if(prolistname){
                              return prolistname;
                            }else{
                              return "not set";
                            }  
                          }else{
                            flagtwo++;
                          }
                        }else{
                          flagno++;
                        }
                    }
                   var sumflag = flagno+flagtwo;
                   if(sumflag==objArr.length){
                     return "not set";
                   }
                  }else{
                     return "not set";
                  }
    }
 function getProindex(productid,provarid){
                var ga_proIndex=localStorage.getItem("ga_proIndex");
                if(ga_proIndex){
                   var prolistname = getListname(productid,provarid);
                    var objArr=JSON.parse(ga_proIndex);
                      var flagno = 0;
                      for(var i=0;i<objArr.length;i++){
                        var objInfo = objArr[i];
                        if(objInfo.productid == productid && objInfo.prolistname == prolistname){
                            return objInfo.proindex;
                        }else{
                          flagno++;
                        }
                    }
                   if(flagno==objArr.length){
                     return 0;
                   }
                }else{
                   return 0;
                }
  }
    function getProname(productid,provarid,protype){
          var ga_cartProm=localStorage.getItem("ga_cartProm");
           if(ga_cartProm){
                      var objArr=JSON.parse(ga_cartProm);
                     var flagno = 0;
                     var flagtwo = 0;
                      for(var i=0;i<objArr.length;i++){
                        var objInfo = objArr[i];
                        if(objInfo.proid == productid){
                          if(objInfo.provarid == provarid){ 
                            if(protype==1){
                              var promoname = objInfo.promotionname;
                              if(promoname){
                                return promoname;
                              }else{
                                return "not set";
                              }
                            }else if(protype==2){
                              var promoid = objInfo.promotionid;
                              if(promoid){
                                return promoid;
                              }else{
                                 return "not set";
                              }
                            }else{
                              return "not set";
                            }
                          }else{
                            flagtwo++;
                          }
                        }else{
                          flagno++;
                        }
                    }
                   var sumflag = flagno+flagtwo;
                   if(sumflag==objArr.length){
                     return "not set";
                   }
                  }else{
                     return "not set";
                  }
    }
   $(".cart__row.cart_pro_itmes").each(function(){
        var precontent = $(this).find(".cart__product-qty").val();
           precontent = parseInt(precontent);
              if(isNumber(precontent)){
                  if(precontent<0){
                    precontent = 1;
                  }else if(precontent==0){
                    precontent = 1;
                  }
              }
     var cartnumno = $(this).index();
     cartnumno=cartnumno-1;
      $(this).find(".remove-cart-btn").on('click', function() {
           var product_selection = "#cartpro-info .click_items"+cartnumno;
           var protitleselection= product_selection + " .cart__product-name";
           var pronumselction = product_selection+" .cart__product-qty";
           var pronumshows= $(pronumselction).val();
            pronumshows = parseInt(pronumshows);
              if(isNumber(pronumshows)){
                  if(pronumshows<0){
                    pronumshows = 1;
                  }else if(pronumshows==0){
                    pronumshows = 1;
                  }
              }
           var protitleshow = document.querySelector(protitleselection).innerText; 
           var prolinameselection= product_selection + " .cart-product-otherinfo .cart-productlistname ";
           var prolistname = document.querySelector(prolinameselection).innerText;
           var proskuselection= product_selection + " .cart-product-otherinfo .cart-productsku ";
           var proskushow = document.querySelector(proskuselection).innerText;
           var prorealskuselection= product_selection + " .cart-product-otherinfo .cart-productrealsku ";
           var prorealskushow = document.querySelector(prorealskuselection).innerText;
           if(prorealskushow=='' || prorealskushow==null || prorealskushow==undefined || prorealskushow.length == 0){
                    prorealskushow = "not set";
           }
           var proidselection= product_selection + " .cart-product-otherinfo .cart-productid ";
           var proidshow = document.querySelector(proidselection).innerText;
           var provariantselection= product_selection + " .cart-provariant";
           var provariantshow = document.querySelector(provariantselection).innerText;
           var procatselection= product_selection + " .cart-product-otherinfo .cart-productcat ";
           var procategoryshow = document.querySelector(procatselection).innerText;
           var propriceselection= product_selection + " .cart__price";
           var propriceshow = document.querySelector(propriceselection).innerText.replace(/[^0-9.]/g, '');  
           var prosubprice = pronumshows*propriceshow;
           // var ga_ilInfo=localStorage.getItem("ga_ilInfo");
           //    if(ga_ilInfo){
           //      var obj=JSON.parse(ga_ilInfo)
           //      if(obj.ts>Date.now()){
           //          var last_ilnm=obj.item_list_name;
           //          var produlistname = last_ilnm;
           //      }else{
           //          localStorage.removeItem("ga_ilInfo");
           //          var produlistname = undefined;
           //      }
           //  }else{
           //       var produlistname = undefined;
           //  }
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                  "event":  "dle_remove_from_cart",
                  "ecommerce":  {
                     "currency": "USD",
                    "value": prosubprice,
                    "items": [
                      {
                        "item_name": protitleshow,
                        "item_id": proidshow,
                        "product_sku": prorealskushow,
                        "price": propriceshow,
                        "item_category": procategoryshow,
                        "item_variant": provariantshow,
                        "item_list_name": getListname(proidshow,proskushow),
                        "index": getProindex(proidshow,proskushow),
                        "quantity": pronumshows,
                        "currency": "USD"
                      }
                    ]
                  }
              });
      })
       // console.log(cartnumno+"*****"+precontent);
        $(this).find(".cart__product-qty").on('input', function() {
            var aftercontent = $(this).val();
             aftercontent = parseInt(aftercontent);
              if(isNumber(aftercontent)){
                  if(aftercontent<0){
                    aftercontent = 1;
                  }
              }
           var product_selection = "#cartpro-info .click_items"+cartnumno;
           var protitleselection= product_selection + " .cart__product-name";
           var protitleshow = document.querySelector(protitleselection).innerText; 
           var prolinameselection= product_selection + " .cart-product-otherinfo .cart-productlistname ";
           var prolistname = document.querySelector(prolinameselection).innerText;
           var proskuselection= product_selection + " .cart-product-otherinfo .cart-productsku ";
           var proskushow = document.querySelector(proskuselection).innerText;
           var prorealskuselection= product_selection + " .cart-product-otherinfo .cart-productrealsku ";
           var prorealskushow = document.querySelector(prorealskuselection).innerText;
           if(prorealskushow=='' || prorealskushow==null || prorealskushow==undefined || prorealskushow.length == 0){
                    prorealskushow = "not set";
           }
           var proidselection= product_selection + " .cart-product-otherinfo .cart-productid ";
           var proidshow = document.querySelector(proidselection).innerText;
           var provariantselection= product_selection + " .cart-provariant";
           var provariantshow = document.querySelector(provariantselection).innerText;
           var procatselection= product_selection + " .cart-product-otherinfo .cart-productcat ";
           var procategoryshow = document.querySelector(procatselection).innerText;
           var propriceselection= product_selection + " .cart__price";
           var propriceshow = document.querySelector(propriceselection).innerText.replace(/[^0-9.]/g, '');
           // var ga_ilInfo=localStorage.getItem("ga_ilInfo");
           //  if(ga_ilInfo){
           //      var obj=JSON.parse(ga_ilInfo)
           //      if(obj.ts>Date.now()){
           //          var last_ilnm=obj.item_list_name;
           //          var produlistname = last_ilnm;
           //      }else{
           //          localStorage.removeItem("ga_ilInfo");
           //          var produlistname = undefined;
           //      }
           //  }else{
           //       var produlistname = undefined;
           //  }
            // var ga_prInfo=localStorage.getItem("ga_prInfo");
            // if(ga_prInfo){
            //   var obj=JSON.parse(ga_prInfo)
            //   if(obj.ts>Date.now()){
            //       var last_prid=obj.promotion_id;
            //       var last_prnm=obj.promotion_name;
            //   }else{
            //       localStorage.removeItem("ga_prInfo");
            //       var last_prid=undefined;
            //       var last_prnm=undefined; 
            //   }
            // }else{
            //     var last_prid=undefined;
            //    var last_prnm=undefined; 
            // }
       
          if (aftercontent != precontent) {   
             var subtotal = aftercontent*propriceshow;
            // var proitems=new Array();
            //      proitems.push({
            //        "item_id": proidshow,
            //        "item_name": protitleshow,
            //        "product_sku": proskushow,
            //        "price": propriceshow,
            //        "item_category": procategoryshow,
            //        "item_variant": provariantshow,
            //        "item_list_name": produlistname,
            //        "index": cartnumno,
            //        "quantity": aftercontent,
            //        "currency": "USD"
            //    });
             if(aftercontent>precontent){
                   var leftnumcon = aftercontent-precontent;
                subtotal = leftnumcon*propriceshow;
             //    console.log({
             //     "event":  "dle_add_to_cart",
             //     "ecommerce":  {
             //          "items": proitems
             //      }
             // });
            dataLayer.push({ ecommerce: null });
                dataLayer.push({
                  "event":  "dle_add_to_cart",
                  "ecommerce":  {
                    "currency": "USD",
                    "value": subtotal,
                    "items": [
                      {
                        "item_name": protitleshow,
                        "item_id": proidshow,
                        "product_sku": prorealskushow,
                        "price": propriceshow,
                        "item_category": procategoryshow,
                        "item_variant": provariantshow,
                        "item_list_name": getListname(proidshow,proskushow),
                        "promotion_name": getProname(proidshow,provariantshow,1),
                        "promotion_id": getProname(proidshow,provariantshow,2),
                        "index": getProindex(proidshow,proskushow),
                        "quantity": leftnumcon,
                        "currency": "USD"
                      }
                    ]
                  }
              });
             }
            if(aftercontent<precontent){
                var leftnumcon = precontent-aftercontent;
                subtotal = leftnumcon*propriceshow;
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                  "event":  "dle_remove_from_cart",
                  "ecommerce":  {
                     "currency": "USD",
                    "value": subtotal,
                    "items": [
                      {
                        "item_name": protitleshow,
                        "item_id": proidshow,
                        "product_sku": prorealskushow,
                        "price": propriceshow,
                        "item_category": procategoryshow,
                        "item_variant": provariantshow,
                        "item_list_name": getListname(proidshow,proskushow),
                        "index": getProindex(proidshow,proskushow),
                        "quantity": leftnumcon,
                        "currency": "USD"
                      }
                    ]
                  }
              });
            }
          }
        });
   })
}

//  Homepage Swiper Slide
//    function swiperList(){
//        var items=new Array();
//        $("#pcSwiper .swiper-slide").each(function(){
//            var iid=$(this).find("img").attr("alt");
//            var inm="homepage_swiper-slide-banner_image";
//            var pid="homepage_swiper-slide-banner_image";
//            var pnm=iid;
//            var cnm=$(this).find("img").attr("src");
//            var csl=$(this).index();
//            if(GAiiv($(this))){
//               items.push({
//                    "item_id": iid,
//                    "item_name": inm,
//                    "promotion_id": pid,
//                    "promotion_name": pnm,
//                    "creative_name": cnm,
//                    "creative_slot": csl
//                })
//            }
//        });
//        if(items.length>0){
//            console.log({
//                "event":  "dle_view_promotion",
//                "ecommerce":  {
//                    "items": items
//                }
//            });
//        };
//    }

//    function viewswiperHandle(){
//        swiperList();
//    }
//    window.addEventListener('scroll', GAgdb(viewswiperHandle, 1000));
// var _w=$("body").width();
// if(_w<1025){
//   window.addEventListener('load',function(){
//   $("#mobSwiper .swiper-slide").eq(1).each(function(){
//            var imgitems=new Array();
//            var csl=0;
//            var iid = "homepage_swiper-slide-banner_image";
//            var pid = "homepage_swiper-slide-banner_image";
//            var cnm = $(this).find("img").attr("src");
//            var pnm = $(this).find("img").attr("alt");
//             imgitems.push({
//                    "item_id": iid,
//                    "item_name": pnm,
//                    "promotion_id": pid,
//                    "promotion_name": pnm,
//                    "creative_name": cnm,
//                    "creative_slot": csl
//             });
//        // if(imgitems.length>0){
//        //     console.log({
//        //         "event":  "dle_view_promotion",
//        //         "ecommerce":  {
//        //             "items": imgitems
//        //         }
//        //     });
//        // };
//              if(imgitems.length>0){
//                   dataLayer.push({ ecommerce: null });
//                   dataLayer.push({
//                     "event": "dle_view_promotion",
//                     "ecommerce": {
//                       "items": imgitems
//                   }
//                 });
//              };
//     })
// })
// }else{
//   window.addEventListener('load',function(){
//   $("#pcSwiper .swiper-slide").eq(1).each(function(){
//            var imgitems=new Array();
//            var csl=0;
//            var iid = "homepage_swiper-slide-banner_image";
//            var pid = "homepage_swiper-slide-banner_image";
//            var cnm = $(this).find("img").attr("src");
//            var pnm = $(this).find("img").attr("alt");
//             imgitems.push({
//                    "item_id": iid,
//                    "item_name": pnm,
//                    "promotion_id": pid,
//                    "promotion_name": pnm,
//                    "creative_name": cnm,
//                    "creative_slot": csl
//             });
//        //  if(imgitems.length>0){
//        //     console.log({
//        //         "event":  "dle_view_promotion",
//        //         "ecommerce":  {
//        //             "items": imgitems
//        //         }
//        //     });
//        // };
//              if(imgitems.length>0){
//                   dataLayer.push({ ecommerce: null });
//                   dataLayer.push({
//                     "event": "dle_view_promotion",
//                     "ecommerce": {
//                       "items": imgitems
//                   }
//                 });
//              };
//     })
// })
// }
$(function () {
  $(".elementor-toc__header").click(function(){
       if($(this).hasClass("off")){
         $(this).removeClass("off");
         $(this).siblings(".elementor-toc__body").slideUp();
       }else{
         $(".elementor-toc__header").siblings(".elementor-toc__body").slideUp();
         $(this).addClass("off");
         $(this).siblings(".elementor-toc__body").slideDown();
       }
    })
})
  $("#home_mul-lifestyle .multicolumn-list .multicolumn-list__item").click(function(){
    var label = $(this).find(".multicolumn-card__title").text().trim();
      dataLayer.push({
		"event_categoty":"home_page",
		"event_action": "life_click",
	    "event_label": label,
	    "event": "cme_lifestyle_click"
	})
  }); 
$(function() {
  var $swiperEl = $('.swiper-subcategories');
  if (!$swiperEl.length) return;

  if ($(window).width() >= 990) return;

  var swiper = new Swiper($swiperEl[0], {
    slidesPerView: 2.2,
    spaceBetween: 15,
    navigation: {
      nextEl: '.subcategory-swiper-container .swiper-button-next',
      prevEl: '.subcategory-swiper-container .swiper-button-prev',
    },
    breakpoints: {
      640: { slidesPerView: 3.2, spaceBetween: 16 },
      768: { slidesPerView: 4.2, spaceBetween: 20 }
    },
    watchOverflow: true,
    resistance: true,
    resistanceRatio: 0.85
  });

  $(window).on('resize', function() {
    if ($(window).width() < 990) {
      if ($swiperEl[0].swiper) {
        $swiperEl[0].swiper.update();
      } else {
        new Swiper($swiperEl[0], { });
      }
    }
  });
});